module.exports = __webpack_public_path__ + "static/media/login_bg.3c3d3516.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/login_bg.png
// module id = 945
// module chunks = 0